export default "__VITE_ASSET__fb472e7d__"